import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["to", "label", "eventLabel", "as", "newTab"],
  _excluded2 = ["to", "newTab", "className", "eventLabel", "as", "label"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Event } from '../../modules/analytics/components';
import { EventPropType } from '../../modules/analytics/types';
import { GoogleAnalytics } from '../../services/analytics';
import { ChildrenPropType } from '../../services/proptypes';
var OutboundLink = /*#__PURE__*/function (_React$Component) {
  _inherits(OutboundLink, _React$Component);
  var _super = _createSuper(OutboundLink);
  function OutboundLink(props) {
    var _this;
    _classCallCheck(this, OutboundLink);
    _this = _super.call(this, props);
    _this.sendOutboundLinkEvent = _this.sendOutboundLinkEvent.bind(_assertThisInitialized(_this));
    _this.onClickWrapper = _this.onClickWrapper.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(OutboundLink, [{
    key: "onClickWrapper",
    value: function onClickWrapper(e) {
      var onClick = this.props.onClick;
      this.sendOutboundLinkEvent();
      if (onClick) {
        onClick(e);
      }
    }
  }, {
    key: "getExtraneousProps",
    value: function getExtraneousProps() {
      var _this$props = this.props,
        to = _this$props.to,
        label = _this$props.label,
        eventLabel = _this$props.eventLabel,
        as = _this$props.as,
        newTab = _this$props.newTab,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return rest;
    }
  }, {
    key: "createContainerProps",
    value: function createContainerProps() {
      var _this$props2 = this.props,
        to = _this$props2.to,
        newTab = _this$props2.newTab,
        className = _this$props2.className,
        eventLabel = _this$props2.eventLabel,
        as = _this$props2.as,
        label = _this$props2.label,
        rest = _objectWithoutProperties(_this$props2, _excluded2);
      var linkProps = newTab ? {
        href: to,
        target: '_blank',
        rel: 'noopener noreferrer'
      } : {
        href: to
      };
      return _objectSpread(_objectSpread(_objectSpread({}, linkProps), rest), {}, {
        className: className,
        'aria-label': label || eventLabel,
        onClick: this.onClickWrapper
      });
    }
  }, {
    key: "sendOutboundLinkEvent",
    value: function sendOutboundLinkEvent() {
      GoogleAnalytics.outbound(this.createLabel(), {
        hitCallback: function hitCallback() {
          return null;
        }
      });
    }
  }, {
    key: "createLabel",
    value: function createLabel() {
      var _this$props3 = this.props,
        label = _this$props3.label,
        eventLabel = _this$props3.eventLabel,
        children = _this$props3.children,
        to = _this$props3.to;
      var childrenLabel = typeof children === 'string' ? children : null;
      return eventLabel || label || childrenLabel || to;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        label = _this$props4.label,
        as = _this$props4.as,
        children = _this$props4.children,
        event = _this$props4.event;
      var elementProps = _objectSpread(_objectSpread({}, this.createContainerProps()), {}, {
        children: children || label
      });
      var Element = /*#__PURE__*/React.createElement(as, elementProps);
      if (event) {
        return /*#__PURE__*/React.createElement(Event, {
          event: event,
          eventType: "click"
        }, Element);
      }
      return Element;
    }
  }]);
  return OutboundLink;
}(React.Component);
export { OutboundLink as default };
OutboundLink.defaultProps = {
  eventLabel: '',
  label: '',
  as: 'a',
  onClick: null,
  newTab: true,
  className: '',
  event: null,
  children: null
};